import React, { useState } from 'react';
import { db } from './firebaseConfig';
import { collection, query, where, getDocs, doc } from 'firebase/firestore';
import { TextField, Button, Box, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';

// Función para obtener la fecha en formato YYYY-MM-DD
const obtenerFechaLocal = () => {
  const fecha = new Date();
  const year = fecha.getFullYear();
  const month = (fecha.getMonth() + 1).toString().padStart(2, '0');
  const day = fecha.getDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const ReporteVentasRango = () => {
  const [fechaInicio, setFechaInicio] = useState(obtenerFechaLocal());
  const [fechaFin, setFechaFin] = useState(obtenerFechaLocal());
  const [resumenVentas, setResumenVentas] = useState([]);
  const [totalQuintales, setTotalQuintales] = useState(0);

  // Función para obtener las ventas por rango de fecha y calcular el total de quintales por día
  const obtenerVentasPorRango = async () => {
    try {
      const ventasRef = collection(db, 'ventas');
      const q = query(ventasRef, where('fecha', '>=', fechaInicio), where('fecha', '<=', fechaFin));
      const querySnapshot = await getDocs(q);

      const ventasPorFecha = {};

      // Agrupamos las ventas por fecha y sumamos la cantidad de quintales
      for (const ventaDoc of querySnapshot.docs) {
        const venta = ventaDoc.data();
        const fecha = venta.fecha;

        // Obtener los detalles de la venta para sumar la cantidad de quintales
        const detallesSnapshot = await getDocs(collection(db, `ventas/${ventaDoc.id}/detalles`));
        detallesSnapshot.forEach((detalleDoc) => {
          const detalle = detalleDoc.data();
          const cantidad = parseFloat(detalle.cantidad);

          if (!ventasPorFecha[fecha]) {
            ventasPorFecha[fecha] = 0;
          }
          ventasPorFecha[fecha] += cantidad;
        });
      }

      // Convertimos el objeto a un array para mostrarlo en la tabla
      const resumen = Object.keys(ventasPorFecha).map((fecha) => ({
        fecha,
        quintales: ventasPorFecha[fecha],
      }));

      const total = resumen.reduce((sum, item) => sum + item.quintales, 0);

      setResumenVentas(resumen);
      setTotalQuintales(total);
    } catch (error) {
      console.error('Error al obtener las ventas por rango:', error);
    }
  };

  return (
    <Box
      sx={{
        mt: 4,
        p: 3,
        backgroundColor: 'white',
        borderRadius: 2,
        boxShadow: 3,
        maxWidth: '800px',
        margin: '0 auto',
        width: '100%',
      }}
    >
      <h2>Reporte de Quintales Vendidos por Rango de Fechas</h2>

      <TextField
        label="Fecha Inicio"
        type="date"
        value={fechaInicio}
        onChange={(e) => setFechaInicio(e.target.value)}
        fullWidth
        margin="normal"
      />
      <TextField
        label="Fecha Fin"
        type="date"
        value={fechaFin}
        onChange={(e) => setFechaFin(e.target.value)}
        fullWidth
        margin="normal"
      />
      <Button
        variant="contained"
        color="primary"
        fullWidth
        onClick={obtenerVentasPorRango}
        sx={{ mt: 2 }}
      >
        Consultar Ventas
      </Button>

      <Table sx={{ mt: 2 }}>
        <TableHead>
          <TableRow>
            <TableCell>Fecha</TableCell>
            <TableCell>Total Quintales Vendidos</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {resumenVentas.length > 0 ? (
            resumenVentas.map((venta, index) => (
              <TableRow key={index}>
                <TableCell>{venta.fecha}</TableCell>
                <TableCell>{venta.quintales}</TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={2} align="center">
                No se encontraron ventas en este rango de fechas
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>

      <h3>Total Quintales en el Rango: {totalQuintales}</h3>
    </Box>
  );
};

export default ReporteVentasRango;
